import type { Item } from './infra';

export interface ContainerGroup {
 key:string;
 kind:''|'compose'|'swarm';
 name:string;
 rows:Item[];
}

/** Docker CREATED age, independent of running/stopped state and restart count. */
export function containerAge(created?:string, now=Date.now()):string {
 const timestamp=created?Date.parse(created):NaN;
 if(!Number.isFinite(timestamp)||timestamp<=0||timestamp>now)return '—';
 const minutes=Math.floor((now-timestamp)/60000),hours=Math.floor(minutes/60),days=Math.floor(hours/24);
 if(days)return days+'일 '+hours%24+'시간 전';
 if(hours)return hours+'시간 '+minutes%60+'분 전';
 return minutes?minutes+'분 전':'방금 생성';
}

/** Keep standalone rows flat while collecting orchestration siblings into one row group. */
export function containerGroups(rows:Item[]):ContainerGroup[] {
 const result:ContainerGroup[]=[],grouped=new Map<string,ContainerGroup>();
 for(const row of rows){
  const kind=row['groupKind']==='compose'||row['groupKind']==='swarm'?row['groupKind'] as 'compose'|'swarm':'';
  const name=typeof row['groupName']==='string'?row['groupName'].trim():'';
  if(!kind||!name){result.push({key:'container:'+String(row['id']),kind:'',name:'',rows:[row]});continue;}
  const key=kind+':'+name;let group=grouped.get(key);
  if(!group){group={key,kind,name,rows:[]};grouped.set(key,group);result.push(group);}
  group.rows.push(row);
 }
 return result;
}
